import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export function isVideo(url) {
  return /\.(mp4|mov|m4a|wav|webm|avi|mkv)(\?.*)?$/i.test(url)
}

//秒转为'HH:mm:ss'
export function secondsToTime(seconds) {
  return dayjs.unix(seconds).utc().format('HH:mm:ss')
}
// 获取链接后缀
export function getFileExtension(filename) {
  const parts = filename.split('.')
  return parts.length > 1 ? parts.pop().toLowerCase() : ''
}
// 获取图片宽高
export function getImageDimensions(file) {
  // 创建一个 Promise，用于异步校验
  return new Promise((resolve, reject) => {
    const img = new Image()
    if (file.fileUrl) {
      img.src = file.fileUrl
    } else {
      img.src = URL.createObjectURL(file)
    }
    img.onload = () => {
      URL.revokeObjectURL(img.src) // 释放内存
      resolve({
        width: img.width,
        height: img.height
      })
    }
    img.onerror = () => {
      URL.revokeObjectURL(img.src)
      reject(new Error('图片无效'))
    }
  })
}
